import { QuestionCategory } from "../../src/types/quiz.types";

export const stringsEng = {
  COMMON: {
    DIFFICULTY: "Difficulty",
    CLIMAPOINTS: "ClimaPoints",
    EARNED: "Earned",
    CARBON_UNIT: "kg CO2e",
    SAVED: "Saved",
    IMPACT: "Impact",
    DAY: "Day",
    STREAK: "Streak",

    CHALLENGE_CATEGORIES: {
      recommended: "For you",
      [QuestionCategory.Food]: "Food",
      [QuestionCategory.Housing]: "Housing",
      [QuestionCategory.Transport]: "Transit",
      [QuestionCategory.Stuff]: "Stuff",
      [QuestionCategory.Other]: "Other",
    },

    DATE_TIME: {
      DAYS: "Days",
      HOURS: "Hours",
      MINUTES: "Minutes",
    },
  },
  ONBOARDING: {
    //'WELCOME' : "Hey welcome to our app",
    HOME_SCREEN: {
      START_TEXT: "Start Your",
      CLIMACTJOURNEY: "Climate Journey",
      GET_STARTED: "Get Started!",
      WELCOMETEXT:
        "We compare your life patterns to your country's average to estimate your carbon footprint. Join our community and start to be part of a positive change for our planet.",
      LOGIN: "Login",
      SIGN_UP: "Sign Up",
      TEACHER_SIGN_UP: "Teacher Sign Up",
    },
    LOGIN: {
      USERNAME: "Username",
      PASSWORD: "Password",
      FORGOT_PASSWORD: "FORGOT YOUR PASSWORD?",
      ERRORS: {
        USERNAME: "Username is required.",
        PASSWORD: "Password is required.",
        NOT_FOUND: "Incorrect username or password.",
      },
    },
    FORGOT_PASSWORD: {
      HEADING: "Forgot Your Password?",
      PROMPT: "Enter your email below to reset your password",
      EMAIL: "Enter your email address",
      ERRORS: {
        EMAIL: "Invalid email address.",
        INVALID_EMAIL: "That email is not registered with an account.",
      },
    },
    FORGOT_PASSWORD_CODE: {
      HEADING: "Email Sent Successfully",
      PROMPT:
        "Enter the code that was sent to your email, and your new password",
      EMAIL: "Enter the code sent to your email",
      PASSWORD: "Enter your new password",
      CONFIRM_PASSWORD: "Confirm your new password",
      RESET: "Reset Password",
      ERRORS: {
        CODE: "A code is required.",
        CODE_LENGTH: "The code must be 7 characters long.",
        PASSWORD: "Your password must be at least 6 characters long.",
        INVALID_CODE: "The code is invalid or expired.",
      },
    },
    SUBMIT: "Submit",
    JOIN: "Join",
    JOIN_CLASS: {
      INSTRUCTIONS: "Enter the key to join a classroom",
      CLASS_ID: "Classroom ID",
      CLASS_INFO: "Classroom Information",
      BY_ACCEPTING:
        "By accepting the invitation, you are allowing the teacher to",
      BY_ACCEPTING_1: "Track your progress in the challenges",
      BY_ACCEPTING_2:
        "Visualize all the submissions you made for the challenges",
      BY_ACCEPTING_3: "Provide feedback on your challenges",
      ERRORS: {
        INVALID_CODE: "Invalid class ID.",
        CLASS_CODE: "Class code required.",
      },
    },
    JOIN_SCHOOL: {
      INSTRUCTIONS: "Enter the key to join a school",
      SCHOOL_ID: "School ID",
      SCHOOL_INFO: "School Information",
      BY_ACCEPTING:
        "By accepting the invitation, you are allowing the school to",
      BY_ACCEPTING_1: "create a class for your students",
      BY_ACCEPTING_2:
        "Visualize all the submissions you made for the challenges",
      BY_ACCEPTING_3: "Provide feedback on your challenges",
      ERRORS: {
        INVALID_CODE: "Invalid school ID.",
        SCHOOL_CODE: "school code required.",
      },
    },
    CREATE_ACCOUNT: {
      FIRSTNAME: "First Name",
      LASTNAME: "Last Name",
      USERNAME: "Username",
      EMAIL: "Email Address",
      CONFIRM_EMAIL: "Confirm Email Address",
      PASSWORD: "Password",
      CONFIRM_PASSWORD: "Confirm Password",
      SIGN_UP: "Sign Up",
      ACCEPT: "I accept the Terms of Service",
      ERRORS: {
        FIRSTNAME: "First name is required.",
        LASTNAME: "Last name is required.",
        USERNAME: "Username is required.",
        EMAIL: "Email address is required",
        CONFIRM_EMAIL: "Must confirm email address.",
        PASSWORD: "Password is required.",
        CONFIRM_PASSWORD: "Must confirm password.",
        PASSWORD_MATCH: "Passwords must match.",
        EMAIL_MATCH: "Emails must match.",
        EXISTS: "Username or email are already registered.",
        USER_DOES_NOT_EXIST: "User does not exist.",
      },
    },
  },
  TEACHER: {
    HOME: {
      CREATE_CLASS: "Create Class",
      EDIT_ASSIGNMENT: "Edit Assignment",
      CREATE_ASSIGNMENT: "Create Assignment",
      LOG_OUT: "Log Out",
    },
    CREATE_CLASS: {
      NAME: "Class name",
      CODE: "Class code",
      DESCRIPTION: "Class description",
      START: "Class start date (format: mm/dd/yy)",
      END: "Class end date (format: mm/dd/yy)",
      SCHOOL: "School code",
      SUBMIT: "Create new class",
      ERRORS: {
        CLASSNAME: "Please input a class name.",
        CLASSCODE: "Please input a class code.",
        DESCRIPTION: "Please input a description.",
        START_DATE: "Please input a start date.",
        END_DATE: "Please input an end date.",
        SCHOOL_CODE: "Please input a school code.",
        LONG_CODE: "Your class code must be less than 16 characters.",
        INVALID_DATE: "Your start date must be a real date.",
        INVALID_END:
          "Your end date must be a real date that comes after the start.",
        INVALID_SCHOOL: "Invalid school code.",
      },
      MODAL: {
        SUCCESS: { TEXT: "Class created successfully!", EMOJI: "🥳" },
        FAILURE: {
          TEXT: "Failed! Please check your inputs.",
          EMOJI: "😢",
        },
      },
    },
    CREATE_ASSIGNMENT: {
      NAME: "Assignment name",
      DUE_DATE: "Due date (format: mm/dd/yy)",
      LEVEL: "Level: easy, medium, or hard",
      CODE: "Associated class code",
      SUBMIT: "Create new assignment",
      POINTS: "Number of points to achieve",
      DESCRIPTION: "Description",
      ERRORS: {
        NAME: "Please input an assignment name.",
        DUE_DATE: "Please input a valid date.",
        LEVEL: "Please input a difficulty level.",
        CLASSCODE: "Please input a class code.",
        POINTS: "Please input a points value.",
        DESCRIPTION: "Please input a description.",
        INVALID_DUE_DATE: "Your due date must be a valid date.",
        INVALID_LEVEL: "Level must be either easy, medium, or hard.",
        INVALID_POINTS: "Points must be greater than 0.",
        INVALID_CLASS: "Invalid class code.",
      },
      MODAL: {
        SUCCESS: { TEXT: "Assignment created successfully!", EMOJI: "🥳" },
        FAILURE: {
          TEXT: "Failed!, Please check your inputs.",
          EMOJI: "😢",
        },
      },
    },
    EDIT_ASSIGNMENT: {
      SUBMIT: "Update assignment"
    },
    CLASS_ITEM: {
      FROM: "from ",
      TO: " to ",
      STUDENTS: " student(s)",
      ACTIVE: " active assignment(s)"
    },
    ASSIGNMENT_LIST: {
      DUE: "Due ",
      CREATE_NEW: "Create new assignment",
      EDIT: "Edit",
      DELETE: "Delete",
      IN_PROGRESS: "In Progress",
      COMPLETED: "Completed"

    },
    CLASS_DETAILS: {
      FOOTPRINT_AVG: "CO2e carbon footprint avg",
      SAVED: "CO2e saved with challenges",
      LEADERBOARD: " Leaderboard "
    },
    TABBAR: {
      CLASSROOM: "Classroom",
      ASSIGNMENTS: "Assignments",
      STUDENTS: "Students"
    },
    CREATE_ASSIGNMENT_FORM: {
      ERROR_MSG: "That class code does not belong to any of your classes.",
      RESPONSE_REASON:  "That class is not yours.",
    },
    EDIT_ASSIGNMENT_FORM: {
      MODAL_TEXT: {
        SUCCESS: "Assignment updated successfully!",
        FAILURE:"Failed to update assignment."
      }
    },
    STUDENT_LIST: {
      TEACHER: "Teacher",
      STUDENTS: "Students",
      MODAL_MESSAGE: "Class code copied successfully.",
      MODAL_EMOJI: "✔️",
      MODAL_CONFIRM: "OK "
    }

  },
  RESULT_SCREEN: {
    BAR_TOP_TEXT: {
      GOAL: "Goal:",
      YOU: "You:",
      COUNTRY: "Canada:",
    },
    BAR_BOTTOM_TEXT: {
      TARGET_TEXT: "Net Zero",
      TARGET_MATRIC: "14.5 Tons/Year",
    },
    RESULT_TEXT: {
      B_AVERAGE: "Below Average",
      AVERAGE: "Average",
      A_AVERAGE: "Above Average",
    },
  },
  QUIZ_RESULT: {
    YOUR_FOOTPRINT: "Your carbon footprint",
    IS: "is",
    YOUR_FOOTPRINT_UNITS: "KGs/year",
    SKIP_TO_CHALLENGES: "Skip to challenges",
    QUIZ_RESULTS_1: {
      UNDERSTAND_YOUR_FOOTPRINT: "Understand your carbon footprint",
      SEE_YOUR: "See your carbon footprint",
      EQUIVALENT: "equivalent",
      EQUIVALENCES: {
        PHONE_1: "KGs of CO2e is the amount of energy needed to charge",
        PHONE_2: "smartphones",
        CAR_1: "KGs of CO2e is the amount produced by driving",
        CAR_2: "km in an average gasoline-powered passenger vehicle",
        TREE_1: "KGs of CO2e is absorbed by",
        TREE_2: "tree seedlings grown for 10 years",
        WASTE_1: "KGs of CO2e is saved when",
        WASTE_2: "bags of recyclable waste are recycled instead of landfilled",
      },
      SEE_YOUR_FOOTPRINT: "See your footprint",
      BREAKDOWN: "breakdown",
    },
    QUIZ_RESULTS_2: {
      SECTION_HEADER_LINE1: "See your carbon footprint",
      SECTION_HEADER_LINE2: "breakdown",
      NEXT_PAGE_LINE1: "See what your carbon footprint",
      NEXT_PAGE_LINE2: "looks like",
      CATEGORIES: {
        FOOD: "Your food footprint is",
        FOOD_TEXT:
          "Some foods and drinks, like beef, create more greenhouse gasses during production and transportation than others. So what you put on your plate impacts your carbon footprint!",
        TRANSPORTATION: "Your transportation footprint is",
        TRANSPORTATION_TEXT:
          "Transportation includes the emissions created when you travel from one place to another using a vehicle such as a car, bus or plane.",
        HOUSING: "Your housing footprint is",
        HOUSING_TEXT:
          "Things like the type of building you live in and how it is heated contribute to your carbon footprint. We didn’t ask questions about housing because, as a student, you have little control over this.",
        STUFF: "The portion of your footprint that comes from stuff is",
        STUFF_TEXT:
          "The “stuff” category includes items you buy/receive, such as electronics, clothes, and furniture. It also includes how you choose to dispose of these items and their packaging.",
        OTHER: "The portion of your footprint that comes from other things is",
        OTHER_TEXT:
          "There are many other things, from pets to sports to medical services, that contribute to your carbon footprint. For now, we used the Canadian average for this value. Later in the app, you will be able to answer more questions to calculate a more accurate value.",
        KGS_CO2: "KGs CO2e/per year",
      },
    },
    QUIZ_RESULTS_AVERAGES: {
      HEADER1: "Carbon footprint average",
      HEADER2: "in KGs of CO2e/year",
      YOUR_AVG: "Your avg",
      WORLD_AVG: "World's avg",
      CANADA_AVG: "Canada's avg",
      START_BUTTON_TEXT: "Start your first challenge!",
      DATA: {
        //in KGs
        CANADA_AVG: 14200,
        WORLD_AVG: 4200,
        CLASS_AVG: 10,
      },
    },
  },
  QUIZ_WELCOME: {
    MEET_BEAR_LINE1: "Meet Nanook,",
    MEET_BEAR_LINE2: "the polar bear!",
    INTRODUCTION:
      "Hi! I'm Nanook, and I'm here to help you make a positive impact on climate change. But first, I need to know a bit more about you before giving a list of personalized challenges. Ready?",
    START_QUIZ_BUTTON: "Start Now!",
  },
  NEW_CHALLENGE: {
    HEADER: "Start a new challenge!",
    SEARCH_BAR_PLACEHOLDER: "Find challenges",
  },
  CHALLENGE_DETAILS: {
    ABOUT: "About this challenge",
    ASSUMPTIONS: "Assumptions",
    SOURCES: "Sources",
    IMPACT: "Impact",
    START: "Start Now",
    COMPLETED: "Completed, click to repeat!",
    ENROLLED: "Enrolled!",
    LOG_CHALLENGE: "Click numbers to log!",
  },
  MENU_DRAWER: {
    HOME: "Home",
    EDIT_PROFILE: "Edit Profile",
    TERMS: "Terms & Conditions",
    USER_GUIDE: "User Guide",
    ABOUT: "About Us",
    CONTACT: "Contact Us",
    LOGOUT: "Sign Out",
    CATEGORIES: {
      ACCOUNT: "Account",
      OTHER: "Other",
    },
  },
  ASSIGNMENT: {
    ASSIGNMENT_ITEM: {
      PROGRESS: "Assignment Progress",
      TIME_REMAINING: "Time Remaining:",
      COMPLETED_ON: "Completed on",
      POINTS_UNIT: "pts",
    },
    ASSIGNMENT_DETAILS: {
      SUBTITLE: {
        GOAL: "Goal:",
        AT_LEAST: "At least",
        // x climapoints
        BY: "by",
        // date
      },
      YOUR_ACHIEVEMENTS: "Your Achievements:",
      GOAL: {
        YOU_REACHED: "You reached",
        // x
        OUT_OF: "out of",
        // y climapoints
      },
      RANK: {
        CLASSROOM_RANK: "Classroom Rank",
        SUBTEXT1: "You are doing better than",
        // x%
        SUBTEXT2: "of other students!",
      },
      AVERAGE: {
        AVG_PER_DAY: "Class Average",
        SUBTEXT1: "The average points earned per student is",
        // x kg CO2e
        SUBTEXT2: ".",
      },
      IMPACT: {
        SUBTEXT: "Together, you and your classmates saved",
        // x kg CO2e
      },
    },
    REFLECTION: {
      TITLE: "How hard was this assignment for you?",
      SCORE_HIGH: "High",
      SCORE_MEDIUM: "Medium",
      SCORE_LOW: "Low",
      TEXT_PLACEHOLDER: "Add Reflection",
      SUBMIT: "Submit",
    },
  },
  DASHBOARD: {
    CHALLENGES: "Challenges",
    SEE_MORE: "see more",
    START_NEW: "START A NEW CHALLENGE",
    GREETING: "Hello,",
    HOW: "How is your ",
    CLIMATE_ACTION: "climate action this week?",
  },
  TERMS: {
    TERMS: "Terms & Conditions",
    INFO_TERMS: `This Agreement governs your use of Myclimact’s Services (“Services” – e.g., and where available, App Store, Myclimact Arcade, Myclimact Books, Myclimact Fitness+, Myclimact Music, Myclimact News, Myclimact News+, Myclimact One, Myclimact Podcasts, Myclimact Podcast Subscriptions, Myclimact TV, Myclimact TV+, Myclimact TV Channels, Game Center, iTunes), through which you can buy, get, license, rent or subscribe to content, Apps (as defined below), and other in-app services (collectively, “Content”). Content may be offered through the Services by Myclimact or a third party. Our Services are available for your use in your country or territory of residence (“Home Country”). By creating an account for use of the Services in a particular country or territory you are specifying it as your Home Country. To use our Services, you need compatible hardware, software (latest version recommended and sometimes required) and Internet access (fees may apply). Our Services’ performance may be affected by these factors.


    You can acquire Content on our Services for free or for a charge, either of which is referred to as a “Transaction.” Each Transaction is an electronic contract between you and Myclimact, and/or you and the entity providing the Content on our Services. However, if you are a customer of Myclimact Distribution International Ltd., Myclimact Distribution International Ltd. is the merchant of record for some Content you acquire from Myclimact Books, Myclimact Podcasts, or App Store as displayed on the product page and/or during the acquisition process for the relevant Service. In such case, you acquire the Content from Myclimact Distribution International Ltd., which is licensed by the Content provider (e.g., App Provider (as defined below), book publisher, etc.). When you make your first Transaction, we will ask you to choose how frequently we should ask for your password for future Transactions. If you enable Touch ID for Transactions, we will ask you to authenticate all Transactions with your fingerprint, and if you enable Face ID for Transactions, we will ask you to authenticate all Transactions using facial recognition. Manage your password settings at any time by following these instructions: https://support.Myclimact.com/HT204030.
        
    Myclimact will charge your selected payment method (such as your credit card, debit card, gift card/code, or other method available in your Home Country) for any paid Transactions, including any applicable taxes. If you have also added it to your Myclimact Wallet, Myclimact may charge your selected payment method in Myclimact Wallet using Myclimact Pay. You can associate multiple payment methods with your Myclimact ID, and you agree that Myclimact may store and charge those payment methods for Transactions. Your primary payment method appears at the top of your account settings payments page.`,
    PRIV_POLICY: "Private Policy",
    INFO_PRIV_POLICY: `Myclimact’s Privacy Policy describes how Myclimact collects, uses, and shares your personal data.

    In addition to this Privacy Policy, we provide data and privacy information embedded in our products and certain features that ask to use your personal information. This product-specific information is accompanied by our Data & Privacy Icon.You will be given an opportunity to review this product-specific information before using these features. You also can view this information at any time, either in settings related to those features and/or online at Myclimact.com/legal/privacy/data. At Myclimact, we believe strongly in fundamental privacy rights — and that those fundamental rights should not differ depending on where you live in the world. That’s why we treat any data that relates to an identified or identifiable individual or that is linked or linkable to them by Myclimact as “personal data,” no matter  where the individual lives. This means that data that directly identifies you — such as your name — is personal data, and also data that does not directly identify you, but that can reasonably be used to identify you — such as the serial number of your device — is personal data. Aggregated data is considered non-personal data for the purposes of this Privacy Policy. This Privacy Policy covers how Myclimact or an Myclimact-affiliated company (collectively, “Myclimact”) handles personal data whether you interact with us on our websites, through Myclimact apps (such as Myclimact Music or Wallet), or in person (including by phone or when visiting our retail stores). Myclimact may also link to third parties on our services or make third-party apps available for download in our App Store. Myclimact’s Privacy Policy does not apply to how third parties define personal data or how they use it. We encourage you to read their privacy policies and know your privacy rights before interacting with them.`,
  },
  ABOUT_US: {
    ABOUTUS: "About Us",
    INFO_ABOUT:
      "Our ecological footprint is the amount of productive land and sea resources we use to meet our daily lifestyle needs. In a world where the planet’s ability to provide for us is finite but our appetite for more “stuff” is growing, we are consuming more resources than what is sustainable. Bill Rees invented the concept here in Vancouver. As a city, we can now measure our greenhouse gas emissions as well as our footprint using the Ecological Footprint Analysis Tool. The numbers tell the story of where to place our greatest effort: analysis of 2011 footprint composition in Vancouver identified priority actions including improved energy efficiency in buildings, lower paper consumption, reduced food waste and less red meat consumption.",
    MISSION: "Mission, Vision, and Values",
    INFO_MISSION: `Climate change, everybody has heard about it. But does everyone understand it? Maybe not. According to United Nation Climate change refers to long-term shifts in temperatures and weather patterns. These shifts may be natural, such as through variations in the solar cycle but since the 1800s, human activities have been the main driver of climate change, primarily due to the burning of fossil fuels (like coal, oil, and gas), which produces heat-trapping gases.. Most people despite knowing these facts about climate change do not care. Is it their fault? the answer is not entirely, because burning fossil fuels has been engraved in human life so much that it is very difficult to get away from it, also some things can not be replaced in our lives to this day. Like you are not going ride a horse to work for 50 miles every day or even cant bike that much. But there are a lot of things we can do! Although there are things that need to change on a bigger scale, the amount of carbon produced by bigger factories can be reduced in some way every person must understand their responsibility to care for the climate and not blame others for not doing it. This emotional connection with nature is important to do something about the problem. This is very hard for adults who lived all their life using a lot of resources for fun but we can do something about future adults. The initial idea of empowering youth to take action was initiated when four young students entered the Westmont Prize competition. They were asked to pitch a solution to a sustainability topic. The students proposed ClimAct, an app that empowers teenagers to help the planet, by giving tips, tracking their impact, and awarding ClimaPoints. This idea was then passed on to Inspire Climact team, they validated the idea using design thinking methodologies. In the research the Climact team did over four months they found out Today’s youth knows about climate change but does know what they can to do help it, they feel they have a lack of resources and time to do action. The Climact team asked themselves two questions after understanding and empathizing with the user group, First, How might we make climact action easy and accessible so that the teenagers don’t feel they lack the resources to do something? Second, how might we educate and motivate youth to have a positive impact on climate? Most teenagers have a mobile or computer device and they love to use it, so an application that is available on all platforms is finalized as the primary goal to execute. The team did market research, and ground research and understood their primary users to come up with the best UI and features that youth will like and that is important for the cause of the application. From the technological point of view, the team decided to work with react native because it is the industry standard for cross-platform application development and the team’s familiarity with the development stack. This report document the whole process of Climact Development from research to a working prototype.`,
  },
  CONTACT_US: {
    HEADER: "Get in touch with us!",
    NAME: "Name",
    EMAIL: "Email",
    MESSAGE: "Your message",
    SEND: "Send",
    SUCCESS_SENT: "Email sent successfuly.",
    FAILURE: "Failed to send email.",
    SUCESS_EMOJI: "🙌",
    FAILURE_EMOJI: "❌"
  },
  FOOTPRINT: {
    HEADER: "Your footprint report!",
    YEARLY_FOOTPRINT_UNITS: "kg CO2e/year",
    TOTAL_SAVED: "kg CO2e saved",
    OFFSET: "kg CO2e offset",
    CALCULATE_AGAIN: "Calculate your footprint again",
    CLASS_AVG: "Classroom avg",
  },
  PROFILE: {
    ASSIGNMENTS: "Assignments completed",
    CHALLENGES: "Total Challenges",
    STREAK: "Days Best Streak",
  },
  CHALLENGE_MODALS: {
    ENROLLED: {
      TEXT: "Successfully enrolled in the challenge!",
      EMOJI: "🙌",
    },
    LOGGED: {
      TEXT: "Successfully logged challenge progress!",
      EMOJI: "🔥",
    },
    COMPLETED: {
      TEXT: "Congrats, you completed the challenge!",
      EMOJI: "🥳",
    },
    FAILED: {
      TEXT: "You cannot complete a challenge \n more than once a day!",
      EMOJI: "❌"
    }
  },
};
